export function getCategoryState(category: string): boolean | null {
  const documentRef = globalThis.document;
  if (!documentRef) return null;
  
  const cookies = documentRef.cookie.split(';');
  const categoryState = cookies.find(cookie => 
    cookie.trim().startsWith(`category-${category}=`)
  );
  
  if (!categoryState) return null;
  
  return categoryState.split('=')[1] === 'true';
}

export function setCategoryState(category: string, isOpen: boolean) {
  const documentRef = globalThis.document;
  if (!documentRef) return;
  
  documentRef.cookie = `category-${category}=${isOpen}; path=/; max-age=${60 * 60 * 24 * 30}`;
}

const TASK_MODE_CHANGE_EVENT = 'task-mode-change';

export function getTaskModeState(): boolean {
  const documentRef = globalThis.document;
  if (!documentRef) return false;
  
  const cookies = documentRef.cookie.split(';');
  const taskModeState = cookies.find(cookie => 
    cookie.trim().startsWith('task-mode=')
  );
  
  if (!taskModeState) return false;
  
  return taskModeState.split('=')[1] === 'true';
}

export function setTaskModeState(showAllTasks: boolean) {
  const documentRef = globalThis.document;
  if (!documentRef) return;
  
  documentRef.cookie = `task-mode=${showAllTasks}; path=/; max-age=${60 * 60 * 24 * 30}`;
  globalThis.dispatchEvent(new Event(TASK_MODE_CHANGE_EVENT));
}

export function subscribeTaskModeState(onStoreChange: () => void) {
  globalThis.addEventListener(TASK_MODE_CHANGE_EVENT, onStoreChange);
  return () => globalThis.removeEventListener(TASK_MODE_CHANGE_EVENT, onStoreChange);
}
